import { shallowEqual, useSelector } from 'react-redux';
import type { StoreState } from '../../types';

/**
 * @deprecated Use useEqualSelector()
 */
export function useShallowEqualSelector<TReturn, TStoreState = StoreState>(
  selector: (state: TStoreState) => TReturn,
) {
  return useSelector<TStoreState, TReturn>(selector, shallowEqual);
}

export { default as useInstanceChanges } from './useInstanceChanges';
